import React, { useState } from 'react';
import {
    Alert, Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, InputAdornment, TextField, Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import axios from 'axios';
import { corPrimaria } from './Comum';

const TAMANHO_MINIMO_SENHA = 8;

export default function AdicionarAdmin(props) {
    const token = localStorage.getItem('token');

    const [nome, setNome] = useState('');
    const [email, setEmail] = useState('');
    const [senha, setSenha] = useState('');
    const [mostrarSenha, setMostrarSenha] = useState(false);
    const [salvando, setSalvando] = useState(false);
    const [erro, setErro] = useState('');

    const handleClose = () => {
        setNome('');
        setEmail('');
        setSenha('');
        setMostrarSenha(false);
        setErro('');
        props.setAdicionarAdmin(false);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (senha.length < TAMANHO_MINIMO_SENHA) {
            setErro(`A senha deve ter pelo menos ${TAMANHO_MINIMO_SENHA} caracteres.`);
            return;
        }
        setErro('');
        try {
            setSalvando(true);
            const { data } = await axios.post(`${process.env.REACT_APP_API_URL}/adicionarAdmin`, {
                nome,
                email,
                senha,
            }, {
                headers: {
                    Authorization: token
                }
            });
            // O back responde 200 com status 400/403 no corpo quando não cria (ex.: e-mail já cadastrado)
            if (data.status !== 200) {
                setErro(data.mensagem || data.erro || "Não foi possível criar o admin.");
                return;
            }
            handleClose();
        } catch (error) {
            console.error("Erro ao adicionar admin:", error);
            setErro("Erro ao adicionar admin. Tente novamente mais tarde.");
        } finally {
            setSalvando(false);
        }
    };

    return (
        <Dialog
            open={props.adicionarAdmin}
            onClose={handleClose}
            maxWidth="xs"
            fullWidth
            // Enter em qualquer campo envia o formulário
            slotProps={{ paper: { component: "form", onSubmit: handleSubmit, autoComplete: "off" } }}
        >
            <DialogTitle sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 2, pb: 1 }}>
                <Box>
                    <Typography sx={{ fontSize: 18, fontWeight: 600 }}>Adicionar admin</Typography>
                    <Typography variant="body2" color="text.secondary">
                        A pessoa terá acesso completo a este painel.
                    </Typography>
                </Box>
                <IconButton size="small" aria-label="Fechar" onClick={handleClose}>
                    <CloseIcon fontSize="small" />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                {erro && <Alert severity="error">{erro}</Alert>}
                <TextField
                    autoFocus
                    required
                    label="Nome"
                    placeholder='Nome completo'
                    type="text"
                    fullWidth
                    value={nome}
                    onChange={(e) => setNome(e.target.value)}
                    variant="outlined"
                    size='small'
                    autoComplete='off'
                />
                <TextField
                    required
                    label="E-mail"
                    autoComplete='off'
                    placeholder='nome@empresa.com.br'
                    type="email"
                    fullWidth
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    variant="outlined"
                    size='small'
                    helperText="Usado para entrar no painel."
                />
                <TextField
                    required
                    label="Senha"
                    autoComplete='new-password'
                    placeholder='Senha de acesso'
                    type={mostrarSenha ? "text" : "password"}
                    fullWidth
                    value={senha}
                    onChange={(e) => setSenha(e.target.value)}
                    variant="outlined"
                    size='small'
                    helperText={`Mínimo de ${TAMANHO_MINIMO_SENHA} caracteres. Envie a senha ao novo admin por um canal seguro.`}
                    slotProps={{
                        input: {
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        size="small"
                                        edge="end"
                                        aria-label={mostrarSenha ? "Ocultar senha" : "Mostrar senha"}
                                        onClick={() => setMostrarSenha((m) => !m)}
                                    >
                                        {mostrarSenha ? <VisibilityOff fontSize="small" /> : <Visibility fontSize="small" />}
                                    </IconButton>
                                </InputAdornment>
                            ),
                        },
                    }}
                />
            </DialogContent>
            <DialogActions sx={{ px: 3, py: 1.5 }}>
                <Button onClick={handleClose} size='small' sx={{ textTransform: "none" }} disabled={salvando}>Cancelar</Button>
                <Button
                    type="submit"
                    variant='contained'
                    size='small'
                    loading={salvando}
                    sx={{ backgroundColor: corPrimaria, textTransform: "none", "&:hover": { backgroundColor: "#153d66" } }}
                >
                    Adicionar admin
                </Button>
            </DialogActions>
        </Dialog>
    );
}
